import {post} from '@/utils/request';
import{mqserver} from '@/utils/baseUrl';

//查询列表
export async function getServiceConfigList(params) {
    return post(mqserver+'/serviceConfig/getServiceConfigList', params, true)
}
//业务配置作废
export async function delServiceConfig(params) {
    return post(mqserver+'/serviceConfig/delServiceConfig', params, true)
}//业务配置保存
export async function saveServiceConfig(params) {
    return post(mqserver+'/serviceConfig/saveServiceConfig', params, true)
}
//业务配置详情查询
export async function getServiceConfigDetail(params) {
    return post(mqserver+'/serviceConfig/getServiceConfigDetail', params, true)
}
//消费服务下拉查询
export async function getConsumerServerDropDownList(params) {
    return post(mqserver+'/consumerServer/getConsumerServerDropDownList', params, true)
}